angular
	.module('AutoPrequal')
	.controller('applicantMortgageCtrl', applicantMortgageCtrl);

applicantMortgageCtrl.$inject = ['$scope', '$rootScope', 'ScrollFactory', 'DataFactory'];

function applicantMortgageCtrl($scope, $rootScope, ScrollFactory, DataFactory) {

	$rootScope.progressCurrent = 8;
	$rootScope.progressMobCurrent = 8;

	$scope.content = DataFactory.appData.content;
	$scope.localContent = DataFactory.appData.content.applicantMortgage;

	$scope.data = DataFactory.appData.applicant;

	$rootScope.applicantMortgageNextStep = function () {
		if ($scope.Mortgage.$valid) {

			DataFactory.appData.applicant.appState.applicantMortgage = true;

			DataFactory.setData($scope.data);

			ScrollFactory.showStep("reviewTerms");
			ScrollFactory.goToStep("reviewTerms");
			return true;
		}
		else {
			angular.forEach($scope.Mortgage.$error, function (field) {
				angular.forEach(field, function (errorField, index) {
					errorField.$setTouched();
					$rootScope.errorNumber = index + 1;
				})
			});
		}
	}

	$scope.prevStep = function () {
		ScrollFactory.showStep("applicantIncome");
		ScrollFactory.goToStep("applicantIncome");
	}
}
